import {
  Schema,
  SchemaInstance,
} from "@redotech/redo-flows-core-schema-common/type-system/schema";
import { camelToSnakeCase } from "@redotech/util/string";
import {
  baseCheckoutPackageSchema,
  examplebaseCheckoutPackageInstance,
} from "./checkout-optimization/checkout-package";
import {
  baseCheckoutTreeSchema,
  examplebaseCheckoutTreeInstance,
} from "./checkout-optimization/checkout-tree";
import {
  basePostPurchaseSchema,
  examplebasePostPurchaseInstance,
} from "./checkout-optimization/post-purchase";
import {
  customEventSchema,
  exampleCustomEventSchemaInstance,
} from "./custom-events/custom-event";
import {
  exampleExtendedWarrantySchemaInstance,
  extendedWarrantySchema,
} from "./extended-warranty";
import { exampleHsaOrderSchemaInstance, hsaOrderSchema } from "./hsa/hsa-order";
import {
  baseHsaQuestionnaireSchema,
  exampleBaseHsaQuestionnaireInstance,
} from "./hsa/hsa-questionnaire-flow";
import {
  exampleYotpoLoyaltyCustomerBirthdaySchemaInstance,
  exampleYotpoLoyaltyExpirationReminderSchemaInstance,
  exampleYotpoLoyaltyOptInSchemaInstance,
  exampleYotpoLoyaltyPointsEarnedSchemaInstance,
  exampleYotpoLoyaltyPointsReminderSchemaInstance,
  exampleYotpoLoyaltyRedemptionCreatedSchemaInstance,
  exampleYotpoLoyaltyRedemptionReminderSchemaInstance,
  exampleYotpoLoyaltyReferralCompletedSchemaInstance,
  exampleYotpoLoyaltyReferralSharedSchemaInstance,
  exampleYotpoLoyaltyTierEarnedSchemaInstance,
  exampleYotpoLoyaltyTierLostSchemaInstance,
  exampleYotpoReviewCreatedSchemaInstance,
  yotpoLoyaltyCustomerBirthdaySchema,
  yotpoLoyaltyExpirationReminderSchema,
  yotpoLoyaltyOptInSchema,
  yotpoLoyaltyPointsEarnedSchema,
  yotpoLoyaltyPointsReminderSchema,
  yotpoLoyaltyRedemptionCreatedSchema,
  yotpoLoyaltyRedemptionReminderSchema,
  yotpoLoyaltyReferralCompletedSchema,
  yotpoLoyaltyReferralSharedSchema,
  yotpoLoyaltyTierEarnedSchema,
  yotpoLoyaltyTierLostSchema,
  yotpoReviewCreatedSchema,
} from "./integrations/yotpo";
import {
  baseExchangeProcessedWithCreditSchema,
  baseMarketingBackInStockSchema,
  baseMarketingBrowseAbandonmentSchema,
  baseMarketingCartAbandonmentSchema,
  baseMarketingCheckoutAbandonmentSchema,
  baseMarketingCsBrowseAbandonmentSchema,
  baseMarketingEmailSchema,
  baseMarketingLowInventorySchema,
  baseMarketingNonShopifyCartAbandonmentSchema,
  baseMarketingNonShopifyCheckoutAbandonmentSchema,
  baseMarketingPriceDropSchema,
  baseMarketingProductSubscriptionCancelledSchema,
  baseRefundReturnSubmittedSchema,
  emailMarketingSignupSchema,
  exampleBaseExchangeProcessedWithCreditSchemaInstance,
  exampleBaseMarketingBackInStockSchemaInstance,
  exampleBaseMarketingBrowseAbandonmentSchemaInstance,
  exampleBaseMarketingCartAbandonmentSchemaInstance,
  exampleBaseMarketingCheckoutAbandonmentSchemaInstance,
  exampleBaseMarketingCsBrowseAbandonmentSchemaInstance,
  exampleBaseMarketingEmailSchemaInstance,
  exampleBaseMarketingLowInventorySchemaInstance,
  exampleBaseMarketingNonShopifyCartAbandonmentSchemaInstance,
  exampleBaseMarketingNonShopifyCheckoutAbandonmentSchemaInstance,
  exampleBaseMarketingPriceDropSchemaInstance,
  exampleBaseMarketingProductSubscriptionCancelledSchemaInstance,
  exampleBaseRefundReturnSubmittedSchemaInstance,
  exampleEmailMarketingSignupSchema,
  exampleLoyaltyLionApproachingTierUpgradeSchemaInstance,
  exampleLoyaltyLionEnrolledSchemaInstance,
  exampleLoyaltyLionReferralCompleteSchemaInstance,
  exampleLoyaltyLionRewardAvailableSchemaInstance,
  exampleLoyaltyLionRuleCompletedSchemaInstance,
  exampleLoyaltyLionTierUpgradeSchemaInstance,
  exampleMarketingDateSchemaInstance,
  exampleMarketingGiftCardBalanceSchemaInstance,
  exampleMarketingWarrantyRegistrationSchemaInstance,
  exampleSegmentMembershipChangeSchemaInstance,
  exampleSmsMarketingSignupSchema,
  loyaltyLionApproachingTierUpgradeSchema,
  loyaltyLionEnrolledSchema,
  loyaltyLionReferralCompleteSchema,
  loyaltyLionRewardAvailableSchema,
  loyaltyLionRuleCompletedSchema,
  loyaltyLionTierUpgradeSchema,
  marketingDateSchema,
  marketingGiftCardBalanceSchema,
  customerGroupMembershipChangeSchema as marketingSegmentMembershipChangeSchema,
  marketingWarrantyRegistrationSchema,
  smsMarketingSignupSchema,
} from "./marketing/marketing";
import {
  exampleMarketingAgentSchemaInstance,
  marketingAgentSchema,
} from "./marketing/marketing-agent";
import {
  isProductVariableName,
  ProductVariableName,
} from "./marketing/product-variables";
import {
  baseAddressVerificationFailedSchema,
  baseNewFulfillmentGroupSchema,
  baseOmsFulfillmentLabelPurchasedSchema,
  baseOmsLabelPurchasedSchema,
  baseOmsOrderReadyForPickupSchema,
  baseOmsPackingSlipPrintedSchema,
  examplebaseAddressVerificationFailedInstance,
  examplebaseNewFulfillmentGroupInstance,
  examplebaseOmsFulfillmentLabelPurchasedInstance,
  examplebaseOmsLabelPurchasedInstance,
  examplebaseOmsOrderReadyForPickupInstance,
  examplebaseOmsPackingSlipPrintedInstance,
} from "./oms";
import {
  exampleProductSubscriptionSchemaInstance,
  ProductSubscriptionSchema,
} from "./product-subscriptions";
import { exampleRecognizeInstance, recognizeSchema } from "./recognize";
import {
  exampleJudgemeReviewSubmittedSchemaInstance,
  judgemeReviewSubmittedSchema,
} from "./reviews/judgeme-review-submitted";
import {
  baseReviewsSchema,
  exampleBaseReviewsSchemaInstance,
} from "./reviews/reviews";
import { exampleRulesSchemaInstance, rulesSchema } from "./rules";
import {
  baseSuppliesShippingSchema,
  exampleBaseSuppliesShippingInstance,
} from "./supplies/supplies-shipping";
import {
  exampleSupportCsatSurveySchemaInstance,
  supportCsatSurveySchema,
} from "./support-csat";
import {
  compensationFlowSchema,
  exampleCompensationFlowSchemaInstance,
} from "./tracking/compensation-flow";
import {
  coverageCreditExpiringSchema,
  exampleCoverageCreditExpiringSchemaInstance,
} from "./tracking/coverage-credit-expiring";
import {
  exampleOrderTrackingSchemaInstance,
  orderTrackingSchema,
} from "./tracking/order-tracking";
import {
  exampleRestockingFlowSchemaInstance,
  restockingFlowSchema,
} from "./tracking/restocking-flow";
import {
  exampleReturnProcessingSchemaInstance,
  returnProcessingSchema,
} from "./tracking/return-processing";
import {
  exampleReturnTrackingSchemaInstance,
  returnTrackingSchema,
} from "./tracking/return-tracking";
import {
  exampleTnplTrackingSchemaInstance,
  tnplTrackingSchema,
} from "./tracking/tnpl-tracking";
import {
  exampleTrackingPageFlowSchemaInstance,
  trackingPageFlowSchema,
} from "./tracking/tracking-page-flow";
import {
  exampleWithdrawalFlowSchemaInstance,
  withdrawalFlowSchema,
} from "./tracking/withdrawal-flow";
import { exampleWorkOrderSchemaInstance, workOrderSchema } from "./work-order";

export enum SchemaType {
  RECOGNIZE = "recognize",
  ORDER_TRACKING = "order_tracking",
  RETURN_TRACKING = "return_tracking",
  RETURN_PROCESSING_FLOW = "return_processing_flow",
  // Compensation and restocking flows are siblings (not children) of
  // RETURN_PROCESSING_FLOW so merchants can configure compensation vs.
  // restocking behavior independently. Each gets its own schema so the
  // available trigger context can diverge as the feature evolves.
  // Dark-launched alongside Processing Flows behind the
  // Advanced processing settings.
  COMPENSATION_FLOW = "compensation_flow",
  RESTOCKING_FLOW = "restocking_flow",
  // Withdrawal flows run on the withdrawal return type at the same lifecycle
  // phases as Compensation. Unlike Compensation/Restocking they are global
  // (team-less docs shared by every team) and have no merchant-facing editor.
  WITHDRAWAL_FLOW = "withdrawal_flow",
  TNPL_TRACKING = "tnpl_tracking",
  EMAIL_MARKETING_SIGNUP = "email_marketing_signup",
  SMS_MARKETING_SIGNUP = "sms_marketing_signup",
  MARKETING_CAMPAIGN = "marketing_campaign",
  REVIEWS = "reviews",
  MARKETING_EMAIL = "marketing_email",
  MARKETING_CART_ABANDONMENT = "marketing_cart_abandonment",
  MARKETING_BROWSE_ABANDONMENT = "marketing_browse_abandonment",
  MARKETING_CHECKOUT_ABANDONMENT = "marketing_checkout_abandonment",
  MARKETING_BIGCOMMERCE_CART_ABANDONMENT = "marketing_bigcommerce_cart_abandonment",
  MARKETING_BIGCOMMERCE_CHECKOUT_ABANDONMENT = "marketing_bigcommerce_checkout_abandonment",
  MARKETING_COMMENTSOLD_CART_ABANDONMENT = "marketing_commentsold_cart_abandonment",
  MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT = "marketing_commentsold_browse_abandonment",
  MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT = "marketing_commentsold_checkout_abandonment",
  MARKETING_BACK_IN_STOCK = "marketing_back_in_stock",
  MARKETING_SEGMENT_MEMBERSHIP_CHANGE = "marketing_segment_membership_change",
  MARKETING_WARRANTY_REGISTRATION = "marketing_warranty_registration",
  MARKETING_LOW_INVENTORY = "marketing_low_inventory",
  MARKETING_DATE = "marketing_date",
  MARKETING_GIFT_CARD_BALANCE = "marketing_gift_card_balance",
  MARKETING_PRICE_DROP = "marketing_price_drop",
  MARKETING_PRODUCT_SUBSCRIPTION_CANCELLED = "marketing_product_subscription_cancelled",
  OMS_NEW_FULFILLMENT_GROUP = "oms_new_fulfillment_group",
  OMS_ORDER_READY_FOR_PICKUP = "oms_order_ready_for_pickup",
  OMS_LABEL_PURCHASED = "oms_label_purchased",
  OMS_FULFILLMENT_LABEL_PURCHASED = "oms_fulfillment_label_purchased",
  OMS_PACKING_SLIP_PRINTED = "oms_packing_slip_printed",
  ADDRESS_VERIFICATION_FAILED = "address_verification_failed",

  // Checkout personalization
  CHECKOUT_TREE = "checkout_tree",
  // Checkout packages
  RCO_CHECKOUT_PACKAGE = "rco_checkout_package",
  // Post-purchase flows
  POST_PURCHASE_FLOW = "post_purchase_flow",
  // Product subscriptions
  PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE = "product_subscription",
  // Extended warranty
  EXTENDED_WARRANTY = "extended_warranty",

  // Tracking page flows
  TRACKING_PAGE_FLOW = "tracking_page_flow",

  // Support rules
  RULES = "rules",
  RULES_V3 = "rules_v3",
  // Support CSAT survey emails
  SUPPORT_CSAT_SURVEY = "support_csat_survey",

  // Yotpo integration
  YOTPO_LOYALTY_EXPIRATION_REMINDER = "yotpo_loyalty_expiration_reminder",
  YOTPO_LOYALTY_POINTS_REMINDER = "yotpo_loyalty_points_reminder",
  YOTPO_LOYALTY_REDEMPTION_REMINDER = "yotpo_loyalty_redemption_reminder",
  YOTPO_LOYALTY_REDEMPTION_CREATED = "yotpo_loyalty_redemption_created",
  YOTPO_LOYALTY_REFERRAL_COMPLETED = "yotpo_loyalty_referral_completed",
  YOTPO_LOYALTY_REFERRAL_SHARED = "yotpo_loyalty_referral_shared",
  YOTPO_LOYALTY_CUSTOMER_BIRTHDAY = "yotpo_loyalty_customer_birthday",
  YOTPO_LOYALTY_OPT_IN = "yotpo_loyalty_opt_in",
  YOTPO_LOYALTY_TIER_EARNED = "yotpo_loyalty_tier_earned",
  YOTPO_LOYALTY_TIER_LOST = "yotpo_loyalty_tier_lost",
  YOTPO_LOYALTY_POINTS_EARNED = "yotpo_loyalty_points_earned",
  YOTPO_REVIEW_CREATED = "yotpo_review_created",

  // LoyaltyLion integration
  LOYALTY_LION_REWARD_AVAILABLE = "loyalty_lion_reward_available",
  LOYALTY_LION_TIER_UPGRADE = "loyalty_lion_tier_upgrade",
  LOYALTY_LION_APPROACHING_TIER_UPGRADE = "loyalty_lion_approaching_tier_upgrade",
  LOYALTY_LION_REFERRAL_COMPLETE = "loyalty_lion_referral_complete",
  LOYALTY_LION_RULE_COMPLETED = "loyalty_lion_rule_completed",

  // Custom events
  CUSTOM_EVENT = "custom_event",
  JUDGEME_REVIEW_SUBMITTED = "judgeme_review_submitted",

  // Return recovery
  REFUND_RETURN_SUBMITTED = "refund_return_submitted",
  EXCHANGE_PROCESSED_WITH_CREDIT = "exchange_processed_with_credit",

  // LoyaltyLion integration
  LOYALTY_LION_ENROLLED = "loyalty_lion_enrolled",

  // Marketing agent (AI-generated content)
  MARKETING_AGENT = "marketing_agent",

  // Work order flows
  WORK_ORDER = "work_order",

  // HSA/FSA (Gale) order emails
  HSA_ORDER = "hsa_order",

  // HSA questionnaire flow view (graph lives on CRDB, not AdvancedFlow)
  HSA_QUESTIONNAIRE = "hsa_questionnaire",

  // Supplies shipping rules. Global (team-less), like WITHDRAWAL_FLOW: Redo is
  // the seller, so one tree prices every merchant.
  SUPPLIES_SHIPPING = "supplies_shipping",

  // Coverage credit expiration reminder: dispatched from an order (no Return
  // document), but needs the store-credit fields ORDER_TRACKING lacks.
  COVERAGE_CREDIT_EXPIRING = "coverage_credit_expiring",
}

export const schemas = {
  [SchemaType.ORDER_TRACKING]: orderTrackingSchema,
  [SchemaType.RETURN_TRACKING]: returnTrackingSchema,
  [SchemaType.RETURN_PROCESSING_FLOW]: returnProcessingSchema,
  [SchemaType.COMPENSATION_FLOW]: compensationFlowSchema,
  [SchemaType.RESTOCKING_FLOW]: restockingFlowSchema,
  [SchemaType.WITHDRAWAL_FLOW]: withdrawalFlowSchema,
  [SchemaType.TNPL_TRACKING]: tnplTrackingSchema,
  [SchemaType.EMAIL_MARKETING_SIGNUP]: emailMarketingSignupSchema,
  [SchemaType.SMS_MARKETING_SIGNUP]: smsMarketingSignupSchema,
  [SchemaType.MARKETING_CAMPAIGN]: baseMarketingEmailSchema,
  [SchemaType.MARKETING_SEGMENT_MEMBERSHIP_CHANGE]:
    marketingSegmentMembershipChangeSchema,
  [SchemaType.REVIEWS]: baseReviewsSchema,
  [SchemaType.MARKETING_EMAIL]: baseMarketingEmailSchema,
  [SchemaType.MARKETING_CART_ABANDONMENT]: baseMarketingCartAbandonmentSchema,
  [SchemaType.MARKETING_BROWSE_ABANDONMENT]:
    baseMarketingBrowseAbandonmentSchema,
  [SchemaType.MARKETING_CHECKOUT_ABANDONMENT]:
    baseMarketingCheckoutAbandonmentSchema,
  [SchemaType.MARKETING_BIGCOMMERCE_CART_ABANDONMENT]:
    baseMarketingNonShopifyCartAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_CART_ABANDONMENT]:
    baseMarketingNonShopifyCartAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT]:
    baseMarketingCsBrowseAbandonmentSchema,
  [SchemaType.MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT]:
    baseMarketingNonShopifyCheckoutAbandonmentSchema,
  [SchemaType.MARKETING_BIGCOMMERCE_CHECKOUT_ABANDONMENT]:
    baseMarketingNonShopifyCheckoutAbandonmentSchema,
  [SchemaType.OMS_NEW_FULFILLMENT_GROUP]: baseNewFulfillmentGroupSchema,
  [SchemaType.OMS_ORDER_READY_FOR_PICKUP]: baseOmsOrderReadyForPickupSchema,
  [SchemaType.OMS_LABEL_PURCHASED]: baseOmsLabelPurchasedSchema,
  [SchemaType.OMS_FULFILLMENT_LABEL_PURCHASED]:
    baseOmsFulfillmentLabelPurchasedSchema,
  [SchemaType.OMS_PACKING_SLIP_PRINTED]: baseOmsPackingSlipPrintedSchema,
  [SchemaType.ADDRESS_VERIFICATION_FAILED]: baseAddressVerificationFailedSchema,
  [SchemaType.MARKETING_BACK_IN_STOCK]: baseMarketingBackInStockSchema,
  [SchemaType.MARKETING_LOW_INVENTORY]: baseMarketingLowInventorySchema,
  [SchemaType.MARKETING_WARRANTY_REGISTRATION]:
    marketingWarrantyRegistrationSchema,
  [SchemaType.MARKETING_DATE]: marketingDateSchema,
  [SchemaType.MARKETING_GIFT_CARD_BALANCE]: marketingGiftCardBalanceSchema,
  [SchemaType.MARKETING_PRICE_DROP]: baseMarketingPriceDropSchema,
  [SchemaType.MARKETING_PRODUCT_SUBSCRIPTION_CANCELLED]:
    baseMarketingProductSubscriptionCancelledSchema,
  [SchemaType.REFUND_RETURN_SUBMITTED]: baseRefundReturnSubmittedSchema,
  [SchemaType.EXCHANGE_PROCESSED_WITH_CREDIT]:
    baseExchangeProcessedWithCreditSchema,
  [SchemaType.LOYALTY_LION_ENROLLED]: loyaltyLionEnrolledSchema,
  [SchemaType.LOYALTY_LION_TIER_UPGRADE]: loyaltyLionTierUpgradeSchema,
  [SchemaType.LOYALTY_LION_APPROACHING_TIER_UPGRADE]:
    loyaltyLionApproachingTierUpgradeSchema,
  [SchemaType.LOYALTY_LION_REFERRAL_COMPLETE]:
    loyaltyLionReferralCompleteSchema,
  [SchemaType.LOYALTY_LION_RULE_COMPLETED]: loyaltyLionRuleCompletedSchema,
  [SchemaType.CHECKOUT_TREE]: baseCheckoutTreeSchema,
  [SchemaType.RCO_CHECKOUT_PACKAGE]: baseCheckoutPackageSchema,
  [SchemaType.POST_PURCHASE_FLOW]: basePostPurchaseSchema,
  [SchemaType.PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE]: ProductSubscriptionSchema,
  [SchemaType.EXTENDED_WARRANTY]: extendedWarrantySchema,
  [SchemaType.TRACKING_PAGE_FLOW]: trackingPageFlowSchema,
  [SchemaType.YOTPO_LOYALTY_EXPIRATION_REMINDER]:
    yotpoLoyaltyExpirationReminderSchema,
  [SchemaType.YOTPO_LOYALTY_POINTS_REMINDER]: yotpoLoyaltyPointsReminderSchema,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_REMINDER]:
    yotpoLoyaltyRedemptionReminderSchema,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_CREATED]:
    yotpoLoyaltyRedemptionCreatedSchema,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_COMPLETED]:
    yotpoLoyaltyReferralCompletedSchema,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_SHARED]: yotpoLoyaltyReferralSharedSchema,
  [SchemaType.YOTPO_LOYALTY_CUSTOMER_BIRTHDAY]:
    yotpoLoyaltyCustomerBirthdaySchema,
  [SchemaType.YOTPO_LOYALTY_OPT_IN]: yotpoLoyaltyOptInSchema,
  [SchemaType.YOTPO_LOYALTY_TIER_EARNED]: yotpoLoyaltyTierEarnedSchema,
  [SchemaType.YOTPO_LOYALTY_TIER_LOST]: yotpoLoyaltyTierLostSchema,
  [SchemaType.YOTPO_LOYALTY_POINTS_EARNED]: yotpoLoyaltyPointsEarnedSchema,
  [SchemaType.YOTPO_REVIEW_CREATED]: yotpoReviewCreatedSchema,
  [SchemaType.LOYALTY_LION_REWARD_AVAILABLE]: loyaltyLionRewardAvailableSchema,
  [SchemaType.CUSTOM_EVENT]: customEventSchema,
  [SchemaType.JUDGEME_REVIEW_SUBMITTED]: judgemeReviewSubmittedSchema,
  [SchemaType.RULES]: rulesSchema,
  [SchemaType.RULES_V3]: rulesSchema,
  [SchemaType.SUPPORT_CSAT_SURVEY]: supportCsatSurveySchema,
  [SchemaType.MARKETING_AGENT]: marketingAgentSchema,
  [SchemaType.WORK_ORDER]: workOrderSchema,
  [SchemaType.HSA_ORDER]: hsaOrderSchema,
  [SchemaType.RECOGNIZE]: recognizeSchema,
  [SchemaType.HSA_QUESTIONNAIRE]: baseHsaQuestionnaireSchema,
  [SchemaType.SUPPLIES_SHIPPING]: baseSuppliesShippingSchema,
  [SchemaType.COVERAGE_CREDIT_EXPIRING]: coverageCreditExpiringSchema,
} as const satisfies Record<SchemaType, Schema>;

export type SchemaFor<T extends SchemaType> = (typeof schemas)[T];

export const schemaInstanceExamples: Record<
  SchemaType,
  SchemaInstance<Schema>
> = {
  [SchemaType.ORDER_TRACKING]: exampleOrderTrackingSchemaInstance,
  [SchemaType.RETURN_TRACKING]: exampleReturnTrackingSchemaInstance,
  [SchemaType.RETURN_PROCESSING_FLOW]: exampleReturnProcessingSchemaInstance,
  [SchemaType.COMPENSATION_FLOW]: exampleCompensationFlowSchemaInstance,
  [SchemaType.RESTOCKING_FLOW]: exampleRestockingFlowSchemaInstance,
  [SchemaType.WITHDRAWAL_FLOW]: exampleWithdrawalFlowSchemaInstance,
  [SchemaType.TNPL_TRACKING]: exampleTnplTrackingSchemaInstance,
  [SchemaType.EMAIL_MARKETING_SIGNUP]: exampleEmailMarketingSignupSchema,
  [SchemaType.SMS_MARKETING_SIGNUP]: exampleSmsMarketingSignupSchema,
  [SchemaType.MARKETING_CAMPAIGN]: exampleBaseMarketingEmailSchemaInstance, // intentionally the same as email
  [SchemaType.MARKETING_SEGMENT_MEMBERSHIP_CHANGE]:
    exampleSegmentMembershipChangeSchemaInstance,
  [SchemaType.REVIEWS]: exampleBaseReviewsSchemaInstance,
  [SchemaType.MARKETING_EMAIL]: exampleBaseMarketingEmailSchemaInstance,
  [SchemaType.MARKETING_CART_ABANDONMENT]:
    exampleBaseMarketingCartAbandonmentSchemaInstance,
  [SchemaType.MARKETING_BROWSE_ABANDONMENT]:
    exampleBaseMarketingBrowseAbandonmentSchemaInstance,
  [SchemaType.MARKETING_CHECKOUT_ABANDONMENT]:
    exampleBaseMarketingCheckoutAbandonmentSchemaInstance,
  [SchemaType.MARKETING_BIGCOMMERCE_CART_ABANDONMENT]:
    exampleBaseMarketingNonShopifyCartAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_CART_ABANDONMENT]:
    exampleBaseMarketingNonShopifyCartAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_BROWSE_ABANDONMENT]:
    exampleBaseMarketingCsBrowseAbandonmentSchemaInstance,
  [SchemaType.MARKETING_COMMENTSOLD_CHECKOUT_ABANDONMENT]:
    exampleBaseMarketingNonShopifyCheckoutAbandonmentSchemaInstance,
  [SchemaType.MARKETING_BIGCOMMERCE_CHECKOUT_ABANDONMENT]:
    exampleBaseMarketingNonShopifyCheckoutAbandonmentSchemaInstance,
  [SchemaType.OMS_NEW_FULFILLMENT_GROUP]:
    examplebaseNewFulfillmentGroupInstance,
  [SchemaType.OMS_ORDER_READY_FOR_PICKUP]:
    examplebaseOmsOrderReadyForPickupInstance,
  [SchemaType.OMS_LABEL_PURCHASED]: examplebaseOmsLabelPurchasedInstance,
  [SchemaType.OMS_FULFILLMENT_LABEL_PURCHASED]:
    examplebaseOmsFulfillmentLabelPurchasedInstance,
  [SchemaType.OMS_PACKING_SLIP_PRINTED]:
    examplebaseOmsPackingSlipPrintedInstance,
  [SchemaType.ADDRESS_VERIFICATION_FAILED]:
    examplebaseAddressVerificationFailedInstance,
  [SchemaType.MARKETING_BACK_IN_STOCK]:
    exampleBaseMarketingBackInStockSchemaInstance,
  [SchemaType.MARKETING_LOW_INVENTORY]:
    exampleBaseMarketingLowInventorySchemaInstance,
  [SchemaType.MARKETING_WARRANTY_REGISTRATION]:
    exampleMarketingWarrantyRegistrationSchemaInstance,
  [SchemaType.MARKETING_DATE]: exampleMarketingDateSchemaInstance,
  [SchemaType.MARKETING_GIFT_CARD_BALANCE]:
    exampleMarketingGiftCardBalanceSchemaInstance,
  [SchemaType.MARKETING_PRICE_DROP]:
    exampleBaseMarketingPriceDropSchemaInstance,
  [SchemaType.MARKETING_PRODUCT_SUBSCRIPTION_CANCELLED]:
    exampleBaseMarketingProductSubscriptionCancelledSchemaInstance,
  [SchemaType.REFUND_RETURN_SUBMITTED]:
    exampleBaseRefundReturnSubmittedSchemaInstance,
  [SchemaType.EXCHANGE_PROCESSED_WITH_CREDIT]:
    exampleBaseExchangeProcessedWithCreditSchemaInstance,
  [SchemaType.LOYALTY_LION_ENROLLED]: exampleLoyaltyLionEnrolledSchemaInstance,
  [SchemaType.LOYALTY_LION_TIER_UPGRADE]:
    exampleLoyaltyLionTierUpgradeSchemaInstance,
  [SchemaType.LOYALTY_LION_APPROACHING_TIER_UPGRADE]:
    exampleLoyaltyLionApproachingTierUpgradeSchemaInstance,
  [SchemaType.LOYALTY_LION_REFERRAL_COMPLETE]:
    exampleLoyaltyLionReferralCompleteSchemaInstance,
  [SchemaType.LOYALTY_LION_RULE_COMPLETED]:
    exampleLoyaltyLionRuleCompletedSchemaInstance,
  [SchemaType.CHECKOUT_TREE]: examplebaseCheckoutTreeInstance,
  [SchemaType.RCO_CHECKOUT_PACKAGE]: examplebaseCheckoutPackageInstance,
  [SchemaType.POST_PURCHASE_FLOW]: examplebasePostPurchaseInstance,
  [SchemaType.PRODUCT_SUBSCRIPTION_UPCOMING_CHARGE]:
    exampleProductSubscriptionSchemaInstance,
  [SchemaType.EXTENDED_WARRANTY]: exampleExtendedWarrantySchemaInstance,
  [SchemaType.TRACKING_PAGE_FLOW]: exampleTrackingPageFlowSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_EXPIRATION_REMINDER]:
    exampleYotpoLoyaltyExpirationReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_POINTS_REMINDER]:
    exampleYotpoLoyaltyPointsReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_REMINDER]:
    exampleYotpoLoyaltyRedemptionReminderSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REDEMPTION_CREATED]:
    exampleYotpoLoyaltyRedemptionCreatedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_COMPLETED]:
    exampleYotpoLoyaltyReferralCompletedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_REFERRAL_SHARED]:
    exampleYotpoLoyaltyReferralSharedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_CUSTOMER_BIRTHDAY]:
    exampleYotpoLoyaltyCustomerBirthdaySchemaInstance,
  [SchemaType.YOTPO_LOYALTY_OPT_IN]: exampleYotpoLoyaltyOptInSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_TIER_EARNED]:
    exampleYotpoLoyaltyTierEarnedSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_TIER_LOST]:
    exampleYotpoLoyaltyTierLostSchemaInstance,
  [SchemaType.YOTPO_LOYALTY_POINTS_EARNED]:
    exampleYotpoLoyaltyPointsEarnedSchemaInstance,
  [SchemaType.YOTPO_REVIEW_CREATED]: exampleYotpoReviewCreatedSchemaInstance,
  [SchemaType.LOYALTY_LION_REWARD_AVAILABLE]:
    exampleLoyaltyLionRewardAvailableSchemaInstance,
  [SchemaType.CUSTOM_EVENT]: exampleCustomEventSchemaInstance,
  [SchemaType.JUDGEME_REVIEW_SUBMITTED]:
    exampleJudgemeReviewSubmittedSchemaInstance,
  [SchemaType.RULES]: exampleRulesSchemaInstance,
  [SchemaType.RULES_V3]: exampleRulesSchemaInstance,
  [SchemaType.SUPPORT_CSAT_SURVEY]: exampleSupportCsatSurveySchemaInstance,
  [SchemaType.MARKETING_AGENT]: exampleMarketingAgentSchemaInstance,
  [SchemaType.WORK_ORDER]: exampleWorkOrderSchemaInstance,
  [SchemaType.HSA_ORDER]: exampleHsaOrderSchemaInstance,
  [SchemaType.RECOGNIZE]: exampleRecognizeInstance,
  [SchemaType.HSA_QUESTIONNAIRE]: exampleBaseHsaQuestionnaireInstance,
  [SchemaType.SUPPLIES_SHIPPING]: exampleBaseSuppliesShippingInstance,
  [SchemaType.COVERAGE_CREDIT_EXPIRING]:
    exampleCoverageCreditExpiringSchemaInstance,
};

interface DynamicVariableBase {
  key: string;
}

export type DynamicVariableText = DynamicVariableBase & {
  type: "text";
  default?: string;
};

export type DynamicVariableUrl = DynamicVariableBase & {
  type: "url";
  text: string;
};

export type DynamicVariable = DynamicVariableText | DynamicVariableUrl;

/**
 * @deprecated Use applyDynamicVariableSyntaxLiquid for new implementations.
 * This function uses the legacy syntax (| `default`) and should only be used
 * for components that haven't been migrated to Liquid templating yet (like packing slips).
 * A database migration is required to convert existing templates to Liquid syntax.
 */
export const applyDynamicVariableSyntax = (
  dynamicVariable: Omit<DynamicVariableText, "type">,
) => {
  return [
    "{{ ",
    camelToSnakeCase(dynamicVariable.key),
    `${dynamicVariable.default ? ` | \`${dynamicVariable.default}\`` : ""}`,
    " }}",
  ].join("");
};

/**
 * Creates dynamic variable syntax using Liquid templating with automatic filters
 * for array and object variables. Use this for email and SMS templates.
 */
export const applyDynamicVariableSyntaxLiquid = (
  params: Omit<DynamicVariableText, "type"> & {
    isHtml?: boolean;
    schemaType: SchemaType | null;
  },
) => {
  const { key, default: defaultValue, isHtml = true, schemaType } = params;
  const snakeCaseKey = camelToSnakeCase(key);
  const camelCaseKey = key;

  let filters = "";

  if (schemaType && schemas[schemaType]) {
    const schema: Schema = schemas[schemaType];
    const fieldDefinition = schema.fields[camelCaseKey];

    if (fieldDefinition) {
      const dataType = fieldDefinition.dataType;

      if (dataType.includes("Multiple")) {
        if (isHtml) {
          filters = '| list: "ordered"';
        } else {
          filters = '| join: ", "';
        }
      } else if (dataType === "Object") {
        filters = '| object: "pairs"';
      }
    }
  }

  if (defaultValue) {
    const defaultFilter = `| default: "${defaultValue}"`;
    filters += filters ? ` ${defaultFilter}` : defaultFilter;
  }

  return ["{{", snakeCaseKey, filters, "}}"].filter(Boolean).join(" ");
};

/** The product variable a trigger's schema carries, if any. */
export function schemaProductVariableName(
  schemaType: SchemaType,
): ProductVariableName | undefined {
  return Object.keys(schemas[schemaType].fields).find(isProductVariableName);
}
